import request from "../utils/request";
//import { PAGE_SIZE } from '../../../constants';

export function fetch({ instanceConfig, action, options, suffix = "" }) {
  const { url, apiKey, projectID } = instanceConfig;
  let prefix = `/project/${projectID}`;
  return request(
    `${url}${prefix}${action}.json?API_KEY=${apiKey}${suffix}`,
    options
  );
}

export function create({ action, options, suffix = "" }) {
  options = { ...options, method: "POST" };
  options.body = JSON.stringify({ data: options.body });
  return fetchNew({ action, options, suffix });
}

export function createExecution(options) {
  const action = "";
  return create({
    action: "/executions/add",
    options: { body: { Execution: options } }
  });
}

export function assignExecution({
  testCaseSelection,
  assignmentMode,
  teamMates,
  executionID
}) {
  let assignMap = {};
  // resolve test case selection
  if (testCaseSelection.testSuite) {
    if (assignmentMode == "self") {
      assignMap["User_" + sessionUser.id] = {
        suites: [testCaseSelection.testSuite]
      };
    }
    if (assignmentMode == "auto-assign") {
    }
  }

  const action = "";

  return create({
    action: "/executions/assignTest/" + executionID,
    options: { body: { Execution: { assign_map: assignMap } } }
  });
}

/*
export function remove(id) {
  return request(`/api/users/${id}`, {
    method: 'DELETE',
  });
}

export function patch(id, values) {
  return request(`/api/users/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(values),
  });
}

export function create(values) {
  return request('/api/users', {
    method: 'POST',
    body: JSON.stringify(values),
  });
}*/
